export default __webpack_public_path__ + "static/media/chia.9e17783e.svg";